import React from 'react';
import { useRef } from 'react';
import './../../pg/Global.css';
import './../Palette.css';
import './Spacer.css';
import './TextParagraph.css';
import { colorMap } from './TextParagraph';

type SpacerProps = {
    Key: number,
    Type: string
};

const Spacer: React.FC<SpacerProps> = ({ Key, Type }) => {
    const mapRef = useRef(colorMap);

    if (Type === 'bg') {
        return (
            <div className={'Spacer'} > </div >
        );
    }

    if (Type === 'alt') {
        return (
            <div className={'Spacer' + 'BgAlt'} > </div >
        );
    }

    let is;
    if (!mapRef.current.has(Key)) {
        is = (Key % 2) !== 0;
        mapRef.current.set(Key, is);
    } else {
        is = mapRef.current.get(Key);
    }
    let isAlt = is ? '' : ' BgAlt';

    return (
        <div className={'Spacer' + isAlt}> </div>
    );
};

export default Spacer;
